import { get, patch } from "@/services/http/backend";
import { PagedResult, SuccessfulResult } from "./types";

/**
 * 恢复共享
 */
export function enableSharedEwaybillShippingAddress(shippingAddressId: number) {
  return patch<SuccessfulResult>(`/v2/shared_ewaybill_shipping_address/${shippingAddressId}:enable`);
}

/**
 * 暂停共享
 */
export function disableSharedEwaybillShippingAddress(shippingAddressId: number) {
  return patch<SuccessfulResult>(`/v2/shared_ewaybill_shipping_address/${shippingAddressId}:disable`);
}

/**
 * 删除共享
 */
export function deleteSharedEwaybillShippingAddress(shippingAddressId: number) {
  return patch<SuccessfulResult>(`/v2/shared_ewaybill_shipping_address/${shippingAddressId}:deleted`);
}

enum SharedEwaybillQuantityChangeRecordType {
  COMPENSATE = "COMPENSATE",
  CONSUME = "CONSUME",
  PROVIDER = "PROVIDER",
  RECYCLE = "RECYCLE",
}

export interface SharedEwaybillQuantityChangeRecord {
  id: number;
  dateCreated: number;
  operatorUserId: number;
  quantity: number;
  sharedEwaybillShippingAddressId: number;
  type: SharedEwaybillQuantityChangeRecordType;
}

/**
 * 查询充值记录
 */
export function getSharedEwaybillShippingAddressRechargeRecords(
  shippingAddressId: number,
  pageNo: number,
  pageSize: number
) {
  return get<PagedResult<SharedEwaybillQuantityChangeRecord>>(
    `/v2/shared_ewaybill_shipping_address/${shippingAddressId}/recharge_records`,
    {
      pageNumber: pageNo,
      pageSize: pageSize,
    }
  );
}

/**
 * 修改共享电子面单余额
 * @param shippingAddressId
 * @param quantity 正数为加，负数为减
 */
export function changeQuantity(shippingAddressId: number, quantity: number) {
  return patch<SuccessfulResult>(`/v2/shared_ewaybill_shipping_address/${shippingAddressId}/quantity/${quantity}`);
}

/**
 * 修改面单消费用户备注名称
 */
export function updateConsumerName(id: number, consumerName: string) {
  return patch<SuccessfulResult>(`/v2/shared_ewaybill_shipping_address/${id}/consumer_name/${consumerName}`);
}

export interface ConsumerInfo {
  /**消费者所属公司 ID。 */
  companyId: number;

  /**消费者备注名称 */
  consumerName: string;

  /**数据的唯一 ID。 发货地址的id */
  id: number;
}

// 查询当前登录用户共享给别人的电子面单消费者信息列表
export function getConsumerInfos() {
  return get<ConsumerInfo[]>("/v2/shared_ewaybill_shipping_address/consumer_infos");
}

export interface ProviderInfo {
  companyId: number;
  id: number;
  providerName: string;
}

// 查询别人共享给当前登录用户共享的电子面单提供者信息列表
export function getProviderInfos() {
  return get<ProviderInfo[]>("/v2/shared_ewaybill_shipping_address/provider_infos");
}
